import { Validators, FormBuilder, FormGroup, ValidatorFn } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { CommonUtilService } from '../../services/CommonUtil.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { AccountAttributesEnum } from './../../enums/account-attributes.enum';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// TODO: refactor this component to be dumb just to return input value,
//  now we have cyclic functionality CommonUtilService -> PromptModalComponent -> CommonUtilService

@Component({
    selector: 'app-prompt-modal',
    templateUrl: './prompt-modal.component.html',
    standalone: false
})
export class PromptModalComponent implements OnInit {
    promptForm: FormGroup;
    isMultiDialog: boolean = false;
    accuracyTier: string;
    accuracyTierText: string;
    readonly checkBoxValue = 'Yes, perform research request and send me updated information';
    readonly accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;


    constructor(
        private formBuilder: FormBuilder,
        private commonUtilService: CommonUtilService,
        private auth: AuthenticationService,
        private readonly matDialogRef: MatDialogRef<PromptModalComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: any,
    ) {

    }

    ngOnInit() {
        const inputValidators: ValidatorFn[] = [
            this.data.mandatoryInput ? Validators.required : null,
            ...(this.data.inputValidators ? this.data.inputValidators : []),
        ].filter(Boolean);

        this.promptForm = this.formBuilder.group({
            inputValue: [this.data.inputValue, inputValidators]
        });
        if (this.data.isReportingModal) {
            this.promptForm.addControl('reportCheckBox', this.formBuilder.control(''));
        }
        this.accuracyTier = this.data['accuracyTier'];
        this.accuracyTierText = this.data['accuracyTierText'];
    }

    submitPrompt() {
        if (this.promptForm.valid) {
            if (
                !this.data.isFileName ||
                this.data.isCompanyExport ||
                this.data.isContactCsvExport
            ) {
                const value: string = this.promptForm.get('inputValue').value;
                const inputValue: string = this.data.inputValue !== value ? this.getFileNameForAsyncExportsHelper(value) : value;
                this.closeModal({
                    success: true,
                    inputValue,
                    ...(this.promptForm.get('reportCheckBox') ? {
                        reportCheckBox: this.promptForm.get('reportCheckBox').value ? this.checkBoxValue : ''
                    } : {}),
                });
                return;
            }

            if (this.data.isCompanyExportAll) {
                // TODO: 5th argument is used as requestCompnyData instead of componentName, should be refactored
                this.commonUtilService.exportCompanyAllCRM({
                    type: 'companyCSV',
                    selectedCompany: this.data.matchIds,
                    isHumanVerified: this.data.requestCompnyData.verified,
                    isInternational: this.data.requestCompnyData.is_international,
                    requestBody: this.data.requestCompnyData,
                    maxCount: this.auth.csvExportLimit(),
                    fileName: this.promptForm.get('inputValue').value,
                    icpIntelJobUUID: this.data.icpIntelJobUUID || null,
                    showIntentAutomationView: this.data?.showIntentAutomationView || false
                });
                this.closeModal();
                return;
            }

            if (this.data.isContactExportAllPreview || this.data.isContactExportAllCSV) {
                const type = this.data.isContactExportAllPreview ? 'Preview' : 'CSV';
                this.commonUtilService.exportAllCRM({
                  type: type,
                  isExportKey: 'list',
                  selectedContacts: this.data.matchIds,
                  revealedContacts: [],
                  fileName: this.promptForm.get('inputValue').value,
                  icpIntelJobUUID: this.data.icpIntelJobUUID || null
                });
                this.closeModal();
                return;
            }

            if (this.data.isReportingModal) {
                this.promptForm.patchValue({
                    reportCheckBox: this.promptForm.get('reportCheckBox').value === true ? this.checkBoxValue : ''
                });
                this.closeModal({
                    success: true,
                    inputValue: this.promptForm.get('inputValue').value,
                    reportCheckBox: this.promptForm.get('reportCheckBox').value
                });
            }
        }
    }

    closeModal(res?) {
        this.matDialogRef.close(res);
    }

    private getFileNameForAsyncExportsHelper(fileName: string): string {
        const {year, month, day, hour, minute, second} = this.commonUtilService.getDateParts(new Date());
        return `${fileName.trim()}_${year}${month}${day}-${hour}:${minute}:${second}`;
    }
}
